import React from 'react';
import PlaceholderPage from '../../components/ui/PlaceholderPage';

const DocumentsPage: React.FC = () => {
  return (
    <PlaceholderPage 
      title="Documents"
      description="Access and manage your legal documents and files."
    />
  );
};

export default DocumentsPage;
